import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation } from '@angular/core';
import { FieldMode } from '@workbuddy/ui/v2/surface.engine/core/contracts/field.binding';
import { SurfaceContext } from '@workbuddy/ui/v2/surface.engine/core/runtime/surface.context/surface.context';
import { WbFieldComponent } from '@workbuddy/ui/v2/surface.engine/core/field/wb.field.component';
import { SectionFieldDeclaration, visibleFieldDeclarations } from '@workbuddy/ui/v2/surface.engine/core/sections/wb.section.component';

// Advanced Settings body — fields from schema region `advanced` (bind-agnostic).
@Component({
  selector: 'wb-financial-document-advanced-panel',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [WbFieldComponent],
  template: `
    <div class="fd-adv-panel">
      <div class="fd-adv-body">
        @for (f of $visibleFields(); track f.field.bind) {
          <div class="fd-adv-field">
            <label class="fd-adv-lbl">{{ f.metadata.displayName || f.field.bind }}</label>
            <wb-field [field]="f.field" [metadata]="f.metadata" [instance]="f.instance" [page]="$page()" [surfaceMode]="$surfaceMode()" errorDisplay="overlay" />
          </div>
        }
      </div>
    </div>
  `,
  styles: [`
    wb-financial-document-advanced-panel {
      display: block;
      height: 100%;
    }
    .fd-adv-panel {
      display: flex;
      flex-direction: column;
      height: 100%;
      min-height: 0;
    }
    .fd-adv-body {
      padding: 16px 18px;
      display: flex;
      flex-direction: column;
      gap: 14px;
      overflow: auto;
      min-height: 0;
      flex: 1;
    }
    .fd-adv-field {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }
    .fd-adv-lbl {
      display: block;
      font-size: 12px;
      font-weight: 500;
      color: #374151;
    }
    .fd-adv-field wb-field .field-label {
      display: none !important;
    }
  `],
})
export class WbFinancialDocumentAdvancedPanelComponent {

  public readonly $fields = input<readonly SectionFieldDeclaration[]>([], { alias: 'fields' });
  public readonly $page = input.required<SurfaceContext>({ alias: 'page' });
  public readonly $surfaceMode = input.required<FieldMode>({ alias: 'surfaceMode' });
  // Own labels sit outside wb-field, so a hide rule on the editor would leave the label. Drop the row.
  protected readonly $visibleFields = computed(() => visibleFieldDeclarations(this.$fields()));
}
